if (!customElements.get('milo-collection-grid')) {
  customElements.define(
    'milo-collection-grid',
    class MiloCollectionGrid extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-milo-scroller]');
        this.previousButton = this.querySelector('[data-milo-previous]');
        this.nextButton = this.querySelector('[data-milo-next]');
        if (!this.scroller || !this.previousButton || !this.nextButton) return;

        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.previousButton.addEventListener('click', () => this.move(-1), options);
        this.nextButton.addEventListener('click', () => this.move(1), options);
        this.scroller.addEventListener('scroll', () => this.updateButtons(), { ...options, passive: true });
        window.addEventListener('resize', () => this.updateButtons(), options);
        this.updateButtons();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      move(direction) {
        const card = this.scroller.querySelector('[data-milo-card]');
        const gap = Number.parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
        const distance = (card?.getBoundingClientRect().width || this.scroller.clientWidth) + gap;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      updateButtons() {
        const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        this.previousButton.disabled = this.scroller.scrollLeft <= 2;
        this.nextButton.disabled = this.scroller.scrollLeft >= maxScroll - 2;
      }
    }
  );
}
